export default {
  businessLogisticsCompanyRelation: {
    header: {
      name: 'Courier Service Name',
      subordinateSubject: 'Affiliated Entity',
      settlementMethod: 'Settlement Method',
    },
    table: {
      name: 'Courier Service Name',
      associatedWarehouse: 'Associated Warehouse',
      subordinateSubject: 'Affiliated Entity',
      settlementMethod: 'Settlement Method',
      deliveryTime: 'Delivery Time'
    },
    dialog: {
      name: 'Courier Service Name',
      namePlaceholder: 'Please select logistics provider name first',
      subordinateSubject: 'Affiliated Entity',
      settlementMethod: 'Settlement Method',
      deliveryTime: 'Delivery Time',
      deliveryTimeBackend: 'Daily Delivery Time',
      associatedWarehouse: 'Associated Warehouse',
      associated: 'Associated'
    },
    rules: {
      salesOrgId: 'Please select owned entity',
      settlementMethod: 'Please select settlement method',
      logisticsBusinessId: 'Please select business name',
      logisticsCompanyId: 'Please select logistics provider name',
    }
  }
};
